import { useMutation, useQuery, useQueryClient } from 'react-query'

import { addRecentConversation } from '../../business-logic/use-cases/AddRecentConversationUseCase'
import { removeRecentConversation } from '../../business-logic/use-cases/RemoveRecentConversationUseCase'
import { recentConversationsQueryConfig } from '../../query-configs'
import { type RecentConversation } from '../../value-objects/RecentConversation'

export interface UseRecentConversationsResult {
  recentConversations: RecentConversation[]
  addRecentConversation: (conversation: RecentConversation) => void
  removeRecentConversation: (conversationId: string) => void
}

export const useRecentConversations = (): UseRecentConversationsResult => {
  const queryClient = useQueryClient()

  const { data = [] } = useQuery({
    ...recentConversationsQueryConfig.getRecentConversations(),
  })

  const invalidateRecentConversations = () => {
    queryClient.invalidateQueries({
      queryKey:
        recentConversationsQueryConfig.getRecentConversations().queryKey,
    })
  }

  const addMutation = useMutation<void, unknown, RecentConversation>({
    mutationFn: (conversation) =>
      Promise.resolve().then(() => addRecentConversation(conversation)),
    onSuccess: invalidateRecentConversations,
  })

  const removeMutation = useMutation<void, unknown, string>({
    mutationFn: (conversationId) =>
      Promise.resolve().then(() => removeRecentConversation(conversationId)),
    onSuccess: invalidateRecentConversations,
  })

  return {
    recentConversations: data,
    addRecentConversation: addMutation.mutate,
    removeRecentConversation: removeMutation.mutate,
  }
}
